import Vue from 'vue/dist/vue.esm'
import UserPasswordForm from 'components/storefront/user-password-form'

export default function buildUserPasswordForm(element) {
  new Vue({
    el: element,
    components: {
      UserPasswordForm
    }
  })
}
